import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

export const LineBackground = styled.div<
  PropsWithChildren<{
    width: string;
  }>
>`
  height: 10px;
  width: ${(props) => props.width};
  margin: 4px 0;
  background: ${({ theme }) => theme.palette.background.default}33;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
`;

export const LineOverlay = styled.div<{
  opacity: number | string;
}>`
  @keyframes shimmer {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 10000000px 0;
    }
  }

  width: 100%;
  height: 100%;
  animation: shimmer 30000s linear infinite;
  opacity: ${(props) => props.opacity};
  background: linear-gradient(
      to right,
      transparent 0%,
      ${({ theme }) => theme.palette.grey.A200} 10%,
      transparent 20%
    )
    repeat-x 0 / 100% auto;
`;
